import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class OrganizacniJednotkyApi extends BaseApi {
	tableUrl(tableName: string) {
		return `/${this.area}/${tableName}/Rows`;
	}

	schemaUrl(tableName: string) {
		return `/${this.area}/${tableName}/Schema`;
	}
}

export const apiProvider = new OrganizacniJednotkyApi(DMS_MODULE, NAME);
